import classNames from 'classnames'
import CurrencyBase from '../CurrencyBase/CurrencyBase'

import styles from './EventCoin.css'

/**
 * For props and methods see [CurrencyBase](http://localhost:3000/#currencybase)
 */
class EventCoin extends CurrencyBase {
    static propTypes = {
        ...CurrencyBase.propTypes,
    }

    static defaultProps = {
        ...CurrencyBase.defaultProps,
    }

    getClassNames = () => {
        const classNameBase = classNames(
            styles.base,
            styles[`base__${this.props.iconPosition}`],
            styles[`base__size-${this.props.size}`], {
                [styles.base__isDisabled]: this.props.isDisabled,
                [styles.base__isNotEnough]: this.props.isNotEnough,
            },
            this.props.mixClassName,
        )

        return classNameBase
    }

    /**
     * Empty override required, otherwise 'styleguide' doesn't understand that render method defined in super class.
     *
     * @return {*}
     */
    render() {
        return super.render()
    }
}

export default EventCoin



// WEBPACK FOOTER //
// ../node_modules/react-mt-bootstrap/lib/components/EventCoin/EventCoin.jsx